export const initialState = {
  email: '',
  password: '',
};
